<template lang='pug'>
  r-form( 
    ref='form'
    reset-text='restablecer'
    submit-text='guardar'
    v-bind='formProps'
    v-model='slGroupedOffer'
    @reset='submitRefresh'
    @submit='submitUpdate'
    )
    template( slot='header-actions' )
      r-dialog(
        content-class='grey lighten-3'
        title='modificar descuento'
        width='540'
        v-model='dialogs.discount'
        )
        r-form(
          submit-text='aplicar'
          v-bind='formDiscountProps'
          v-model='slGroupedOfferDiscount'
          @submit='submitDiscount'
          )
      r-dialog(
        content-class='grey lighten-3'
        title='modificar precio'
        width='540'
        v-model='dialogs.price'
        )
        r-form(
          submit-text='aplicar'
          v-bind='formPercentageProps'
          v-model='slGroupedOfferPrice'
          @submit='submitPrice'
          )
      //r-dialog(
        content-class='grey lighten-3'
        title='busqueda rapida'
        width='540'
        v-model='dialogs.search'
        )
        r-form(
          submit-text='buscar'
          )
    template( slot='sl-selected-grouped-offer-items' )
      v-btn( color='info' @click='showDiscountDialog' ) descuento &nbsp;
        v-icon edit
      v-btn( color='info' @click='showPriceDialog' ) precio &nbsp;
        v-icon edit
      //v-btn( color='secondary' @click='showSearchDialog' ) buscar &nbsp;
        v-icon search
</template>

<script>
  //
  import { RBtnAction, RDialog, RForm } from '@/components/reusable_components/next'
  import translatorService from '@/services/translator'
  //
  import SlGroupedOfferDiscountFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferDiscountFields'
  import SlGroupedOfferFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferFields'
  import SlGroupedOfferModel from '@/models/Sale/SlGroupedOffer'
  import SlGroupedOfferPriceFields from '@/views/Sale/SlGroupedOffer/SlGroupedOfferPriceFields'
  import SlOfferModel from '@/models/Sale/SlOffer'
  //
  export default {
    components: {
      RBtnAction,
      RDialog,
      RForm,
    },
    computed: {
      fieldsProps() {
        return {
          sl_selected_grouped_offer_mapper: this.mapWhProduct,
        }
      },
      formDiscountProps() {
        return {
          fields: SlGroupedOfferDiscountFields,
        }
      },
      formPercentageProps() {
        return {
          fields: SlGroupedOfferPriceFields,
        }
      },
      formProps() {
        return {
          fields: SlGroupedOfferFields(this.fieldsProps),
          title: `editar oferta masiva #${this.$route.params.id}`
        }
      },
      viewProps() {
        return {
          title: `Oferta masiva #${this.$route.params.id}`,
        }
      },
    },
    data() {
      return {
        slGroupedOffer: {
          sl_offers: [],
        },
        slGroupedOfferDiscount: {
          discount: 0,
        },
        slGroupedOfferPrice: {
          offer_price: 0,
        },
        dialogs: {
          discount: false,
          price: false,
          search: false,
        },
      }
    },
    methods: {
      getSlGroupedOffer() {
        return SlGroupedOfferModel
          .include('g_branch_office,sl_offers.wh_product')
          .find(this.$route.params.id)
      },
      mapWhProduct(whProduct) {
        //
        whProduct.branchOfficeId = this.$store.getters['AuthModule/branchOfficeID']
        //
        return whProduct
      },
      setSlGroupedOffer(slGroupedOffer) {
        this.slGroupedOffer = slGroupedOffer.reset()
        this.slGroupedOfferSaved = slGroupedOffer.clone().reset()
      },
      showDiscountDialog() {
        this.dialogs.discount = true
      },
      showPriceDialog() {
        this.dialogs.price = true
      },
      showSearchDialog() {
        this.dialogs.search = true
      },
      showRefreshError() {
        this.showErrorSnackbar('Error al cargar oferta masiva.')
      },
      showRefreshSuccess() {
        this.showSuccessSnackbar('Oferta masiva cargada exitosamente.')
      },
      showUpdateError(event) {
        this.showErrorSnackbar(translatorService(SlGroupedOfferModel, event.response.data))
      },
      showUpdateSuccess() {
        this.showSuccessSnackbar('Oferta masiva guardada exitosamente.')
      },
      submitDiscount(event) {
        this
          .slGroupedOffer
          .setDiscount(event.discount)
      },
      submitPrice(event) {
        this
          .slGroupedOffer
          .setPrice(event.offer_price)
      },
      submitRefresh() {
        return this
          .toWait(true)
          .then(this.toRefresh)
          .then(this.toWait)
      },
      submitUpdate() {
        return this
          .toWait(true)
          .then(this.toCreate)
          .then(this.toDelete)
          .then(this.toUpdate)
          .then(this.toWait)
      },
      toCreate() {
        //
        const new_offers = this.slGroupedOffer.sl_offers
        const old_offers = this.slGroupedOfferSaved.sl_offers
        //const new_offers_to_create = new_offers.filter(item => old_offers.every(offer => offer.id !== item.id))
        //
        //Promise.all(new_offers_to_create.map(item))
        if (new_offers.some(item => !old_offers.some(offer => offer.id == item.id))) {
          return this
            .slGroupedOffer
            .toCreate(old_offers)
            .create()
        }
        return true
      },
      toDelete() {
        if (this.slGroupedOfferSaved.sl_offers.some(item => this.slGroupedOffer.sl_offers.every(offer => offer.id != item.id))) {
          return this
            .slGroupedOfferSaved
            .toDelete(this.slGroupedOffer.sl_offers)
            .delete()
        }
        return true
      },
      toRedirect() {
        this.$router.push({ name: 'sl-grouped-offer-list' })
      },
      toRefresh() {
        return this
          .getSlGroupedOffer()
          .then(this.setSlGroupedOffer)
          .catch(this.showRefreshError)
          .then(this.showRefreshSuccess)
      },
      toUpdate() {
        return this
          .slGroupedOffer
          .toUpdate()
          .edit()
          .then(this.showUpdateSuccess)
          .then(this.toRefresh)
          .catch(this.showUpdateError)
      },
      toWait(value = false) {
        return this.$refs.form.setWait(value)
      },
    },
    created() {
      this.setTitle(this.viewProps.title)
    },
    mounted() {
      this.toRefresh()
    }
  }
</script>